import { createStore } from 'vuex'

import { account } from './account.module';

export const store = new createStore({
    modules: {
        account
    }
});